import type { MeData } from '@magnetar/admin-api-interfaces'

export type ViewMode =
  | 'default'
  | 'admin'
  | 'provider'
  | 'clinic'
  | 'clinic_group'
  | 'ad'
  | 'ad_supplier_group'

export function homeForUser(user: MeData): string {
  if (user.role_type === 'sys_admin') return '/admin'
  if (user.role_type === 'investor') return '/investor/clinics'

  const s = user.scopes
  if (!s) return '/'

  // provider scope wins over any child scopes (provider_admin / custom role with provider scope_type)
  if (s.provider_id) {
    return `/provider/${s.provider_id}`
  }

  if (s.clinic_group_ids?.length === 1) return `/clinic-group/${s.clinic_group_ids[0]}`
  if ((s.clinic_group_ids?.length ?? 0) > 1) return '/'

  if (s.ad_supplier_group_ids?.length === 1) return `/ad-supplier-group/${s.ad_supplier_group_ids[0]}`
  if ((s.ad_supplier_group_ids?.length ?? 0) > 1) return '/'

  if (s.clinic_ids?.length === 1) return `/clinic/${s.clinic_ids[0]}`
  if ((s.clinic_ids?.length ?? 0) > 1) return '/'

  if (s.supplier_ids?.length === 1) return `/ad-supplier/${s.supplier_ids[0]}`
  if ((s.supplier_ids?.length ?? 0) > 1) return '/'

  return '/'
}

export function homeModeForUser(user: MeData): ViewMode {
  if (user.role_type === 'sys_admin') return 'admin'
  if (user.role_type === 'investor') return 'default'

  const s = user.scopes
  if (!s) return 'default'

  // Priority: provider > group > individual — derive from scope presence
  if (s.provider_id) return 'provider'
  if ((s.clinic_group_ids?.length ?? 0) > 0) return 'clinic_group'
  if ((s.ad_supplier_group_ids?.length ?? 0) > 0) return 'ad_supplier_group'
  if ((s.clinic_ids?.length ?? 0) > 0) return 'clinic'
  if ((s.supplier_ids?.length ?? 0) > 0) return 'ad'

  return 'default'
}
